import * as React from 'react';
import { INVOICES } from '../../utils/RouteConstants';
import { ISearchInvoice } from '../../models/IInvoice';
import { InvoiceNotification } from '../../models/INotifications';
import { Notification } from "./Notification";

interface IInvoiceNotifications {
    sentInvoices: InvoiceNotification | undefined;
    approvedInvoices: InvoiceNotification | undefined;
}

export const InvoiceNotifications: React.FunctionComponent<IInvoiceNotifications> = ({ sentInvoices, approvedInvoices }) => {

    const sentInvoicesSearchParams: ISearchInvoice | undefined = sentInvoices ? { statusId: sentInvoices.statusId, pageNumber: 1, pageSize: 10 } : undefined;
    const approvedInvoicesSearchParams: ISearchInvoice | undefined = approvedInvoices ? { statusId: approvedInvoices.statusId, pageNumber: 1, pageSize: 10 } : undefined;

    return (
        <>
            {
                sentInvoices && sentInvoices.amount > 0 ?
                    <Notification state={sentInvoicesSearchParams} amount={sentInvoices.amount} linkText="Fakturor som inväntar godkännande" linkTo={`/${INVOICES}`} />
                    : null
            }
            {
                approvedInvoices && approvedInvoices.amount > 0 ?
                    <Notification state={approvedInvoicesSearchParams} amount={approvedInvoices.amount} linkText="Fakturor som inväntar attestering" linkTo={`/${INVOICES}`} />
                    : null
            }
        </>
    )
}